interface LoadingOverlayProps {
  show: boolean;
  currentStep: 'open-file' | 'status' | 'init' | 'sync' | 'done';
  isLoadingUser: boolean;
}

/**
 * Overlay de carregamento simplificado
 * ✅ UI/UX: Mostra apenas "Organizando dados" durante hydrate do snapshot
 * As etapas técnicas detalhadas são mostradas no primeiro loading (OrderPreparationOverlay)
 */
export function LoadingOverlay({ show, isLoadingUser }: LoadingOverlayProps) {
  if (!show) return null;

  return (
    <div className="absolute inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center px-4">
      <div className="bg-navy-800 border border-navy-700 rounded-xl shadow-2xl w-full max-w-md p-5">
        <h2 className="text-lg font-semibold text-white mb-1">
          {isLoadingUser ? 'Carregando usuário' : 'Organizando dados'}
        </h2>
        <p className="text-xs text-gray-400 mb-4">
          {isLoadingUser 
            ? 'Aguarde enquanto carregamos suas informações.' 
            : 'Finalizando preparação da visualização...'}
        </p>
        <div className="flex items-center justify-center py-4">
          <div className="relative">
            {/* Spinner principal */}
            <div className="w-10 h-10 border-3 border-blue-500/30 rounded-full" />
            <div className="absolute inset-0 w-10 h-10 border-3 border-blue-400 border-t-transparent rounded-full animate-spin" />
          </div>
        </div>
      </div>
    </div>
  );
}

